// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-field{flex-basis:50%}.buy-dialog-customer-form .v-text-field.v-input--dense{padding-top:12px}", ""]);
// Exports
module.exports = exports;
